import { readMore } from './readmore';

let page = 1;
let isLoading = false;

/**
 * Set active parameters
 */
function setParameters(filters, dates, tags, page, search) {
  const forParams = {};

  filters.forEach((filter) => {
    const slug = filter.post_type.slice(0, 2);
    if (forParams[slug]) {
      forParams[slug].push(filter.id);
    } else {
      forParams[slug] = [filter.id];
    }
  });

  if (dates?.length) forParams.da = dates;
  if (tags?.length) forParams.tag = tags;
  if (page) forParams.page = page;
  if (search) forParams.zoekterm = search;

  const parameters = new URLSearchParams(forParams);
  return '?' + parameters.toString();
}

/**
 * Get active filters
 */
function getActiveFilters() {
  const filters = [];
  $('.filter__item__label.active[data-filter="post-type"]').each(function () {
    filters.push({
      post_type: $(this).data('postType'),
      id: $(this).data('id'),
    });
  });
  return filters;
}

/**
 * Get active date filters
 */
function getActiveDateFilter() {
  const dates = [];
  $('.filter__item__label.active[data-filter="date"]').each(function () {
    dates.push($(this).data('id'));
  });
  return dates;
}

/**
 * Get active tags
 */
function getActiveTags() {
  const tags = [];
  $('.filter__item__label.active[data-filter="tag"]').each(function () {
    tags.push($(this).data('id'));
  });
  return tags;
}

/**
 * Set active filters from URL parameters
 */
function setActiveFiltersByParameters() {
  const params = new URLSearchParams(window.location.search);
  const filters = [];

  for (const [key, value] of params) {
    const items = value.split(',');
    const mappings = {
      sp: 'spreker',
      ca: 'categorie',
      se: 'serie',
      lo: 'locatie',
      ev: 'event-type',
    };
    if (mappings[key]) {
      items.forEach((item) =>
        filters.push({ post_type: mappings[key], id: item })
      );
    }
  }
  return filters;
}

/**
 * Set active dates from URL parameters
 */
function setActiveDateByParameters() {
  const params = new URLSearchParams(window.location.search);
  return params.has('da') ? params.get('da').split(',') : [];
}

/**
 * Set active tags from URL parameters
 */
function setActiveTagsByParameters() {
  const params = new URLSearchParams(window.location.search);
  return params.has('tag') ? params.get('tag').split(',') : [];
}

/**
 * Sync checkboxes met active labels
 */
function syncCheckboxes() {
  $('.filter__item__label').each(function () {
    const $checkbox = $(this).find('input[type="checkbox"]');
    $checkbox.prop('checked', $(this).hasClass('active'));
  });
}

/**
 * Load posts via AJAX
 */
function ajax_load_posts(emptyContainer, search, loadPage) {
  if (isLoading) return;
  isLoading = true;

  const filters = getActiveFilters();
  const dates = getActiveDateFilter();
  const tagsArray = getActiveTags();
  const tags = tagsArray.join(',');
  const currentSearch =
    search !== undefined ? search : $('.filter__search').val();

  page = loadPage || 1;

  const params = setParameters(filters, dates, tagsArray, page, currentSearch);
  window.history.pushState('', '?', params);

  $.ajax({
    url: window.ajaxvars.ajax_url,
    type: 'post',
    data: {
      action: 'doorbrekers_filter_posts',
      page: page,
      post_type: $('.filter').data('post-type'),
      filters: filters,
      date: dates,
      tags: tags,
      search: currentSearch,
    },
    beforeSend: () => {
      if (emptyContainer) $('.archive__container').empty();
      $('.filter__pagination').remove();
      $('.archive__container').append(
        '<div class="archive__container__loader"></div>'
      );
    },
    success: (data) => {
      $('.archive__container__loader').remove();
      $('.archive__container').append(data);
      syncCheckboxes(); // Sync na laden
      isLoading = false;
    },
    error: (xhr, status, error) => {
      console.error('AJAX error:', status, error);
      isLoading = false;
    },
  });
}

/**
 * Edit filters via AJAX
 */
function ajax_edit_filters(load = false) {
  if (isLoading) return;
  isLoading = true;

  const filters = load ? setActiveFiltersByParameters() : getActiveFilters();
  const dates = load ? setActiveDateByParameters() : getActiveDateFilter();
  const tags = load ? setActiveTagsByParameters() : getActiveTags();
  const currentSearch = $('.filter__search').val();
  const params = setParameters(filters, dates, tags, page, currentSearch);

  $.ajax({
    url: window.ajaxvars.ajax_url,
    type: 'post',
    data: {
      action: 'doorbrekers_edit_filters',
      post_type: $('.filter').data('post-type'),
      filters: filters,
      date: dates,
      tags: tags.join(','),
      search: currentSearch,
    },
    beforeSend: () => {
      $('.filter__item__label').prop('disabled', true);
    },
    success: (data) => {
      $('.filter').html(data);
      readMore();
      syncCheckboxes(); // Sync na filter update
      $('.filter__reset').toggle(params !== '?');
      $('.filter__item__label').prop('disabled', false);
      isLoading = false;
    },
    error: () => {
      isLoading = false;
    },
  });
}

// Event handlers
$(document).ready(() => {
  if ($('.archive__container').length) {
    ajax_edit_filters(true);
    ajax_load_posts(true, $('.filter__search').val(), 1);
  }
});

$(document).on('click', '.filter__item__label', function (e) {
  e.preventDefault();
  $(this).toggleClass('active');
  const $checkbox = $(this).find('input[type="checkbox"]');
  $checkbox.prop('checked', $(this).hasClass('active'));
  ajax_load_posts(true, $('.filter__search').val(), 1);
  ajax_edit_filters();
});

$(document).on('click', '.filter__reset', () => {
  $('.filter__item__label.active').removeClass('active');
  $('.filter__item input[type="checkbox"]').prop('checked', false); // Reset alle checkboxes
  $('.filter__search').val('');
  window.history.pushState('', '?', '?');
  ajax_load_posts(true, '', 1);
  ajax_edit_filters();
});

$('.filter__search').on('change', function () {
  ajax_load_posts(true, $(this).val(), 1);
  ajax_edit_filters();
});

$(document).on('click', '.filter__load-more', function () {
  const nextPage = $(this).data('page') + 1;
  ajax_load_posts(false, $('.filter__search').val(), nextPage);
});

$('.filter__search__btn').on('click', () => {
  if ($('.filter__search').val()) {
    $('.filter__search').val('').trigger('change');
  }
});

$('.filter-toggle').on('click', function () {
  $(this).toggleClass('active');
  $('.filter').slideToggle();
});
